var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilityProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "#13B76E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9419 11.7905C21.8425 11.6271 21.6312 11.5228 21.3993 11.5228H15.3744L19.0211 6.70722C19.1308 6.56231 19.1326 6.38256 19.0256 6.23641C18.9187 6.09025 18.7196 5.99994 18.5039 6L13.3565 6.00044C13.1429 6.0005 12.9453 6.089 12.8377 6.23297L6.08185 15.27C5.97344 15.4149 5.97268 15.5941 6.07981 15.7396C6.18693 15.8851 6.3856 15.9749 6.60069 15.9749H12.5872L10.8436 21.4175C10.7753 21.6305 10.9057 21.8519 11.1572 21.9503C11.2429 21.9838 11.3349 22 11.426 22C11.6021 22 11.7746 21.9396 11.8918 21.8275L21.8648 12.2879C22.0114 12.1477 22.0414 11.954 21.9419 11.7905Z",
    fill: "#13B76E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityProgram);
export default __webpack_public_path__ + "static/media/utility-program.0b3e0977c96452e5d868f404c0419f0b.svg";
export { ForwardRef as ReactComponent };